import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock, AlertTriangle, ArrowRight, ShieldCheck, CreditCard } from 'lucide-react';
export function PricingSection() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 42,
    seconds: 31
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (num: number) => num.toString().padStart(2, '0');
  return <section id="pricing" className="py-24 bg-card relative border-y border-white/5" data-id="element-173">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-[500px] bg-cyan-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-174"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 relative z-10" data-id="element-175">
        <div className="text-center mb-12" data-id="element-176">
          <div className="inline-flex items-center gap-2 text-red-400 font-bold mb-4" data-id="element-177">
            <Clock className="w-5 h-5" data-id="element-178" /> PRECIO DE LANZAMIENTO — CIERRA EN:
          </div>
          <div className="flex justify-center gap-4 text-4xl md:text-5xl font-display font-bold text-white mb-6" data-id="element-179">
            <div className="bg-dark px-4 py-2 rounded-lg border border-white/10" data-id="element-180">
              {formatTime(timeLeft.hours)}
              <span className="text-sm text-gray-500 block" data-id="element-181">hs</span>
            </div>
            <span className="py-2" data-id="element-182">:</span>
            <div className="bg-dark px-4 py-2 rounded-lg border border-white/10" data-id="element-183">
              {formatTime(timeLeft.minutes)}
              <span className="text-sm text-gray-500 block" data-id="element-184">min</span>
            </div>
            <span className="py-2" data-id="element-185">:</span>
            <div className="bg-dark px-4 py-2 rounded-lg border border-white/10 text-cyan-400" data-id="element-186">
              {formatTime(timeLeft.seconds)}
              <span className="text-sm text-gray-500 block" data-id="element-187">seg</span>
            </div>
          </div>

          <div className="flex items-center justify-center gap-2 text-yellow-500 font-medium mb-6" data-id="element-188">
            <AlertTriangle className="w-5 h-5" data-id="element-189" /> Después sube $20 USD. No
            vuelve.
          </div>

          <div className="max-w-md mx-auto bg-dark p-4 rounded-xl border border-white/10" data-id="element-190">
            <div className="flex justify-between text-sm mb-2" data-id="element-191">
              <span className="text-gray-400 flex items-center gap-2" data-id="element-192">
                <span className="w-2 h-2 rounded-full bg-red-500" data-id="element-193"></span> Cupos
                al precio de lanzamiento
              </span>
              <span className="text-white font-bold" data-id="element-194">68% tomados</span>
            </div>
            <div className="w-full bg-white/10 rounded-full h-2.5" data-id="element-195">
              <div className="bg-gradient-to-r from-red-500 to-orange-500 h-2.5 rounded-full" style={{
              width: '68%'
            }} data-id="element-196"></div>
            </div>
          </div>
        </div>

        <h2 className="text-3xl md:text-4xl font-display font-bold text-center text-white mb-12" data-id="element-197">
          ELEGÍ TU MEGA PACK IA
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-198">
          {/* Basic Tier */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="glass-card rounded-2xl p-8 border border-white/10 flex flex-col" data-id="element-199">
            <div className="text-3xl mb-4" data-id="element-200">📘</div>
            <h3 className="text-2xl font-bold text-white mb-2" data-id="element-201">MEGA PACK IA</h3>
            <p className="text-cyan-400 font-medium mb-6 pb-6 border-b border-white/10" data-id="element-202">
              3 Tomos + 3 Bonos
            </p>

            <p className="text-gray-400 text-sm mb-8 flex-grow" data-id="element-203">
              <strong className="text-white" data-id="element-204">Ideal para:</strong> Personas que
              quieren dominar ChatGPT, DeepSeek y Claude desde cero con prompts
              reales y ejemplos prácticos.
            </p>

            <div className="mb-8" data-id="element-205">
              <span className="text-gray-500 line-through text-xl mr-2" data-id="element-206">
                $45.000
              </span>
              <span className="text-4xl font-bold text-white" data-id="element-207">
                $19.990 <span className="text-xl text-gray-400" data-id="element-208">ARS</span>
              </span>
            </div>

            <a href="https://www.soportesaberdigital.com/cart/49127910277359:1" target="_blank" rel="noopener noreferrer" className="w-full bg-white/10 hover:bg-white/20 text-white font-bold py-4 px-6 rounded-xl transition-colors flex items-center justify-center gap-2" data-id="element-209">
              QUIERO MI MEGA PACK IA <ArrowRight className="w-5 h-5" data-id="element-210" />
            </a>
          </motion.div>

          {/* Premium Tier */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-gradient-to-b from-cyan-900/40 to-dark rounded-2xl p-8 border-2 border-cyan-500 relative flex flex-col transform md:-translate-y-4 shadow-[0_0_30px_rgba(0,229,255,0.15)]" data-id="element-211">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-cyan-500 text-dark font-bold px-4 py-1 rounded-full text-sm flex items-center gap-1 whitespace-nowrap" data-id="element-212">
              ⭐ MÁS VENDIDO
            </div>

            <div className="text-3xl mb-4" data-id="element-213">🏆</div>
            <h3 className="text-2xl font-bold text-white mb-2" data-id="element-214">
              MEGA PACK IA + WORKFLOW TOTAL
            </h3>
            <p className="text-cyan-400 font-medium mb-6 pb-6 border-b border-white/10" data-id="element-215">
              3 Tomos + 3 Bonos + Manual de Operaciones 3-en-1
            </p>

            <p className="text-gray-300 text-sm mb-8 flex-grow" data-id="element-216">
              <strong className="text-white" data-id="element-217">Ideal para:</strong> Emprendedores,
              freelancers y profesionales que quieren conectar las 3 IAs en un
              sistema de trabajo real.
            </p>

            <div className="mb-8" data-id="element-218">
              <span className="text-gray-500 line-through text-xl mr-2" data-id="element-219">
                $65.000
              </span>
              <span className="text-4xl font-bold text-cyan-400" data-id="element-220">
                $27.990 <span className="text-xl text-cyan-400/60" data-id="element-221">ARS</span>
              </span>
            </div>

            <a href="https://www.soportesaberdigital.com/cart/49127949336815:1" target="_blank" rel="noopener noreferrer" className="w-full bg-cyan-400 hover:bg-cyan-300 text-dark font-bold py-4 px-6 rounded-xl transition-all flex items-center justify-center gap-2 animate-pulse-glow" data-id="element-222">
              QUIERO EL MEGA PACK IA + WORKFLOW TOTAL{' '}
              <ArrowRight className="w-5 h-5" data-id="element-223" />
            </a>
          </motion.div>
        </div>

        <div className="mt-12 flex flex-col items-center gap-4 text-sm text-gray-400" data-id="element-224">
          <div className="flex items-center gap-2" data-id="element-225">
            <ShieldCheck className="w-5 h-5 text-green-400" data-id="element-226" /> Pago 100% seguro
            | ⚡ Acceso en 5 minutos
          </div>
          <div className="flex items-center gap-2" data-id="element-227">
            <CreditCard className="w-5 h-5" data-id="element-228" /> Tarjeta / Transferencia / PayPal
            / Mercado Pago
          </div>
        </div>
      </div>
    </section>;
}